import { FileUploadProgressDTO } from "@js/DTO/FileUploadProgressDTO.cs.d";
import { DealFileAttachmentHelper } from "@js/helpers/DealFileAttachmentHelper";
import { FileAttachmentHelper } from "@js/helpers/FileAttachmentHelper";
import ProductHelper from "@js/helpers/ProductHelper";
import { AuthService } from "@js/services/AuthService";
import { DealLenderService } from "@js/services/Deal/DealLenderService";
import { SharedHeadsOfTermsService } from "@js/services/Deal/SharedHeadsOfTermsService";
import { FeedBackService } from "@js/services/FeedBackService";
import { RoleService } from "@js/services/RoleService";
import { SelectListService } from "@js/services/SelectListService";
import { UserService } from "@js/services/UserService";
import {
  ApplicationUser,
  ApplicationUserCrudClient,
  BridgingSubmitOfferRequest,
  CaseLenderStateEnum,
  CommercialDeal,
  CommercialDealClient,
  DealFileAttachment,
  DealFileAttachmentClient,
  DealLender,
  DealLenderClient,
  DealLenderMessage,
  DealLenderMessageClient,
  FeedBack,
  FeedBackClient,
  FileAttachment,
  InterestRateTypeEnum,
  LoanRepaymentTypeEnum,
  MessageRoleEnum,
  ModuleEnum,
  ProductClient,
  UserClient,
} from "@src/apis/ModularClient";
import { BaseHeadsOfTermsController } from "./BaseHeadsOfTermsController";
import { IndexService } from "@js/services/IndexService";
import { ODataHelper } from "@js/helpers/ODataHelper";

export class CommercialHeadsOfTermsController extends BaseHeadsOfTermsController {
  static $inject = [
    "$routeParams",
    "$rootScope",
    "$location",
    "RoleService",
    "DealLenderMessageClient",
    "DealFileAttachmentClient",
    "$window",
    "CommercialDealClient",
    "DealLenderService",
    "DealLenderClient",
    "SelectListService",
    "FeedBackService",
    "FeedBackClient",
    "UserService",
    "UserClient",
    "ApplicationUserCrudClient",
    "IndexService",
    "AuthService",
    "SharedHeadsOfTermsService",
    "DealFileAttachmentHelper",
    "FileAttachmentHelper",
    "ProductClient",
    "ODataHelper",
    "$timeout",
  ];

  isCommercial: boolean = true;
  dealLenders: DealLender[];
  showInformationMessage: boolean = false;
  messageContent: string;

  showDirection: boolean = false;

  toggleHoTDetailSection: boolean = false;
  toggleRejectSection: boolean = false;
  toggleWithdrawSection: boolean = false;

  // show different sections to Lender based on which button clicked on Case Dashboard
  showFeedbackSectionLender: boolean = false;
  showHoTDetailSectionLender: boolean = false;
  showRejectSectionLender: boolean = false;
  showWithdrawSectionLender: boolean = false;

  showTsAndCsModal: boolean = false;
  showTsAndCsForm: boolean = false;
  sendingMessage: boolean = false;
  goToUserDashboard: boolean = false;

  currentDeal: CommercialDeal;

  grossLoanCalcVal: number = 0;
  builLoanCalcVal: number = 0;
  landLoanCalcVal: number = 0;
  monetaryLAFee: number = 0;
  monetaryLEFee: number = 0;
  lenderTask: string = "";

  isRejectClicked: boolean = false;
  isWithdrawClicked: boolean = false;
  isConfirmClicked: boolean = false;
  isSubmitClicked: boolean = false;

  //Lender Message
  newChatMessage: string = "";
  showFullMessageId: number;

  //files
  fileUpload: DealFileAttachment[];
  uploadingFiles: FileUploadProgressDTO[];
  openModal: boolean = false;
  module = ModuleEnum.DIP;

  showFullLenderMessage = false;
  showFullBorrowerMessage = false;
  monthlyInterestRate: number = 0;
  showAutofill: boolean = false;

  mortgageProductType = [];
  loanRepaymentType = [];

  //Lender/Broker feedback properties
  showLenderFeedBackModal: boolean = false;
  showBrokerFeedBackModal: boolean = false;
  prevPath: string;
  brokerName: string;
  brokerOrganisationName: string;
  lendingForm: ng.IFormController;

  //Deleteing a chat message
  selectedDealLenderMessageDto: DealLenderMessage;
  showdeleteChatMessageModal: boolean = false;
  showConfirmDeleteButton: boolean = false;
  productTypeText: string = null;

  noLenderOrMoreLenderError: boolean = false;

  constructor(
    $routeParams: ng.route.IRouteParamsService,
    private $rootScope: ng.IRootScopeService,
    private $location: ng.ILocationService,
    roleService: RoleService,
    dealLenderMessageClient: DealLenderMessageClient,
    private dealFileAttachmentClient: DealFileAttachmentClient,
    private $window: ng.IWindowService,
    private commercialDealClient: CommercialDealClient,
    private dealLenderService: DealLenderService,
    private dealLenderClient: DealLenderClient,
    private selectListService: SelectListService,
    private feedBackService: FeedBackService,
    private feedBackClient: FeedBackClient,
    private userService: UserService,
    userClient: UserClient,
    applicationUserCrudClient: ApplicationUserCrudClient,
    indexService: IndexService,
    private $auth: AuthService,
    private sharedHeadsOfTermsService: SharedHeadsOfTermsService,
    private dealFileAttachmentHelper: DealFileAttachmentHelper,
    private fileAttachmentHelper: FileAttachmentHelper,
    private productClient: ProductClient,
    oDataHelper: ODataHelper,
    protected $timeout: ng.ITimeoutService,
  ) {
    super(
      $routeParams,
      userClient,
      roleService,
      dealLenderMessageClient,
      applicationUserCrudClient,
      indexService,
      oDataHelper,
    );
    this.userClient.getCurrentUserAutofill().then((response) => {
      this.showAutofill = response;
    });

    if (this.$routeParams.openModule && this.$routeParams.openModule == "withdraw") {
      this.toggleWithdrawSection = true;
    } else if (this.$routeParams.openModule && this.$routeParams.openModule == "reject") {
      this.toggleRejectSection = true;
    } else if (this.$routeParams.openModule) {
      this.toggleFeedbackSection = true;
    }

    if (this.$routeParams.dealId && this.$routeParams.DealLenderId) {
      this.dataLoading = true;

      this.commercialDealClient
        .fetch(this.$routeParams.dealId)
        .then((response) => {
          this.currentDeal = response;
          if (this.currentDeal) {
            this.dealLenderClient
              .fetchByDealId(
                this.$routeParams.dealId,
                this.roleService.getIsLenderVisible(),
                this.$routeParams.DealLenderId,
              )
              .then((response) => {
                this.dealLenders = response;
                if (this.$routeParams.DealLenderId) {
                  if (this.dealLenders.length != 1) {
                    this.noLenderOrMoreLenderError = true;
                    return;
                  }
                  this.currentCaseLender = this.dealLenders[0];

                  this.fileUpload =
                    this.currentDeal.attachments?.filter((f) => {
                      return f.dealLenderId == this.$routeParams.DealLenderId;
                    }) || [];
                }
              })
              .finally(() => {
                this.populateLenderInformation(this.currentUser);

                // Scroll to the bottom of the page if we're expanding the message notification area
                if (this.toggleFeedbackSection) {
                  // the timeout delay of 100 is a bit of a hack and may not work well on slower networks
                  $timeout(function () {
                    window.scrollTo(0, document.body.scrollHeight);
                  }, 100);
                }
              });

            this.lenderTask = sessionStorage.getItem("lenderTask");
            if (this.lenderTask != null && this.lenderTask.length > 0) {
              switch (this.lenderTask) {
                case "reject":
                  this.showRejectSectionLender = true;
                  break;
                case "withdraw":
                  this.showWithdrawSectionLender = true;
                  break;
                case "feedback":
                  this.showFeedbackSectionLender = true;
                  this.updateCaseLenderMessageReadDatetime();
                  break;
                case "terms":
                  this.showHoTDetailSectionLender = true;
                  break;
                default:
                  break;
              }
            }

            this.productTypeText = ProductHelper.getProductTypeFullName(this.currentDeal.productType);
          } else {
            if ((this.$rootScope as any).selectedUser) {
              this.$location.path("/dashboard");
            }
          }
        })
        .finally(() => {
          this.dataLoading = false;
          this.getCurrentUserAndRoles();
        });
    }

    // this.BasisOfInterestRateOptions = this.selectListService.GetInterestRateBasis();
    // this.InterestRateTypeOptions = this.selectListService.GetInterestRateType();
    this.mortgageProductType = this.selectListService.GetInterestRateType();
    this.loanRepaymentType = this.selectListService.GetLoanRepaymentTypeOptions();
  }

  checkingIfUserIsLender() {
    this.roleService.isLenderUser().then((response) => {
      this.isLender = response;
    });
  }

  checkingIfUerIsBroker() {
    this.dataLoading = true;
    this.roleService
      .isBroker()
      .then((response) => {
        this.isBroker = response;
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  checkingIfUserIsAdmin() {
    this.dataLoading = true;
    this.roleService
      .isAdminUser()
      .then((response) => {
        this.isAdmin = response;
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  checkingIfUserIsClient() {
    this.dataLoading = true;
    this.roleService
      .isClientUser()
      .then((response) => {
        this.isClient = response;
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  /** Redirects to the case dashboard */
  goToCaseDashboard() {
    this.showFeedbackSectionLender = false;
    this.showHoTDetailSectionLender = false;
    this.showRejectSectionLender = false;
    this.showWithdrawSectionLender = false;
    if (
      this.isBroker &&
      this.currentCaseLender &&
      !this.currentCaseLender.isLenderReviewComplete &&
      (this.currentCaseLender.status == CaseLenderStateEnum.Offered ||
        this.currentCaseLender.status == CaseLenderStateEnum.Rejected ||
        this.currentCaseLender.status == CaseLenderStateEnum.Withdrawn)
    ) {
      this.prevPath = "commercialcasedashboard";
      this.feedBackDTO.isLenderFeedback = true;
      this.showLenderFeedBackModal = true;
    } else {
      this.$location.path("/commercialcasedashboard/" + this.currentDeal.id);
    }
  }

  /** Close modal after send feedback */
  closeModal() {
    this.showDirection = false;
    this.showTsAndCsModal = false;
    this.showInformationMessage = false;
    this.isConfirmClicked = false;
    this.showdeleteChatMessageModal = false;
    if (this.goToUserDashboard) {
      this.$auth.clearSelectedNavMenuAndFilterStorageData();
      this.$location.path("/userdashboard");
      this.goToUserDashboard = false;
      this.showFeedbackSectionLender = false;
      this.showHoTDetailSectionLender = false;
      this.showRejectSectionLender = false;
      this.showWithdrawSectionLender = false;
    }

    if (this.prevPath) {
      if (this.isLender) {
        this.$auth.clearSelectedNavMenuAndFilterStorageData();
        this.$location.path("/userdashboard");
      } else {
        this.$location.path(`/${this.prevPath}/${this.currentDeal.id}`);
      }
    }
  }

  goToLending() {
    if (
      this.isBroker &&
      this.currentCaseLender &&
      !this.currentCaseLender.isLenderReviewComplete &&
      (this.currentCaseLender.status == CaseLenderStateEnum.Offered ||
        this.currentCaseLender.status == CaseLenderStateEnum.Rejected ||
        this.currentCaseLender.status == CaseLenderStateEnum.Withdrawn)
    ) {
      this.prevPath = "dealforum";
      this.feedBackDTO.isLenderFeedback = true;
      this.showLenderFeedBackModal = true;
    } else {
      this.$location.path("/dealforum/" + this.currentDeal.id);
    }
  }

  saveUpdatedCaseLender(): void {
    this.dealLenderClient.addUpdate(this.currentCaseLender).then((response) => {
      this.currentCaseLender = response;
      this.messageContent = "Your changes have been saved.";
      this.showInformationMessage = true;
    });
  }

  dummyDIP() {
    this.dealLenderService.dummyDIP(this);
  }

  /** Process the Reject button being clicked*/
  rejectClicked(): void {
    this.isRejectClicked = true;
    this.dealLenderClient
      .rejectCase(this.currentCaseLender)
      .then((response) => {
        this.currentCaseLender.status = response.caseLenderState;
        this.brokerName = response.dealBrokerName;
        this.brokerOrganisationName = response.dealBrokerOrganisationName;
        this.messageContent = "The borrower has been notified you have rejected their application.";
      })
      .catch((error) => {
        this.messageContent = "Sorry, something went wrong. Please try again.";
        this.isRejectClicked = false;
      })
      .finally(() => {
        this.goToUserDashboard = true;
        this.currentCaseLender.isBrokerReviewComplete || this.currentDeal.brokerOrganisationId == null || !this.isLender
          ? (this.showInformationMessage = true)
          : this.showBrokerFeedBack();
      });
  }

  ///**Process the Withdraw button being clicked */
  withdrawClicked(): void {
    this.isWithdrawClicked = true;
    this.dealLenderClient
      .withdrawHoT(this.currentCaseLender)
      .then((response) => {
        this.currentCaseLender.status = response.caseLenderState;
        this.brokerName = response.dealBrokerName;
        this.brokerOrganisationName = response.dealBrokerOrganisationName;
        this.messageContent = "The borrower has been notified you have withdrawn terms for their application.";
      })
      .catch((error) => {
        this.messageContent = "Sorry, something went wrong. Please try again.";
        this.isWithdrawClicked = false;
      })
      .finally(() => {
        this.goToUserDashboard = true;
        this.currentCaseLender.isBrokerReviewComplete || this.currentDeal.brokerOrganisationId == null || !this.isLender
          ? (this.showInformationMessage = true)
          : this.showBrokerFeedBack();
      });
  }

  ///**Process the Submit button being clicked */
  submitClicked() {
    this.isConfirmClicked = true;
    this.showTsAndCsModal = true;
  }

  ///**Heads of Terms Submit button clicked event */
  submitHoTClicked() {
    // Close the Heads of Terms' Terms and Conditions modal
    this.showTsAndCsModal = false;
    this.sendingMessage = true;

    var request = {
      dealLender: this.currentCaseLender,
      dealLenderStatus: this.currentCaseLender.status,
    } as BridgingSubmitOfferRequest;

    // Submit the Heads of Terms
    this.dealLenderClient
      .submitOffer(request)
      .then((response) => {
        this.currentCaseLender.status = response.dealLenderStatus;
        this.brokerName = response.dealBrokerName;
        this.brokerOrganisationName = response.dealBrokerOrganisationName;
        this.messageContent = "Thank you for submitting a Decision in Principle.";
        this.goToUserDashboard = true;
      })
      .catch((error) => {
        this.messageContent =
          "Sorry, something went wrong while submitting your Decision in Principle. Please try again.";
        this.isConfirmClicked = false;
      })
      .finally(() => {
        this.currentCaseLender.isBrokerReviewComplete || this.currentDeal.brokerOrganisationId == null || !this.isLender
          ? (this.showInformationMessage = true)
          : this.showBrokerFeedBack();
        this.sendingMessage = false;
      });
  }

  /**
   * Process the Send Feedback button being clicked
   * @param message
   */
  sendChatMessage() {
    this.dataLoading = true;
    let DealChatMessage = {
      message: this.newChatMessage,
      dealId: this.$routeParams.dealId,
      deal: null,
      dealLenderId: this.$routeParams.DealLenderId,
      dealLender: null,
      senderUser: null,
      senderUserId: this.currentUser.id,
      senderRole: this.getSenderMessageRole(),
      recipientRoles: this.isLender ? MessageRoleEnum.Client | MessageRoleEnum.Broker : MessageRoleEnum.Lender,
    } as DealLenderMessage;

    this.dealLenderMessageClient
      .addUpdateCustom(DealChatMessage)
      .then((dealChatMessageResponse) => {
        this.currentCaseLender.dealLenderMessage.push(dealChatMessageResponse);
        this.newChatMessage = null;
      })
      .catch((error) => {
        this.messageContent = "Sorry, something went wrong while sending feedback. Please try again.";
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  showFullChatMessage(index) {
    this.showFullMessageId = index;
  }

  onFileSelect(files: FileAttachment[], module: ModuleEnum) {
    if (files.length > 0) {
      this.dealFileAttachmentHelper
        .UploadFileListInSync(
          files,
          this.uploadingFiles,
          this.$routeParams.dealId,
          this.fileUpload,
          module,
          this.$routeParams.DealLenderId,
        )
        .then((result) => {
          this.openModal = false;
        });
    }
  }

  downloadFile(file: DealFileAttachment) {
    this.dataLoading = true;
    this.dealFileAttachmentClient
      .getAmazonFileAccessUri(file.fileLocation)
      .then((uri) => {
        this.$window.open(uri);
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  deleteFile(file: DealFileAttachment) {
    this.fileUpload.splice(this.fileUpload.indexOf(file), 1);
    this.dealFileAttachmentClient.markAsDeleted(file.id).then((result) => { }); //remove on the server
  }

  disableDip() {
    return !this.showActionButtons();
  }

  showActionButtons() {
    if (
      this.currentCaseLender &&
      (this.currentCaseLender.status == CaseLenderStateEnum.Received ||
        this.currentCaseLender.status == CaseLenderStateEnum.Rejected ||
        this.currentCaseLender.status == CaseLenderStateEnum.Offered ||
        this.currentCaseLender.status == CaseLenderStateEnum.Cancelled ||
        this.currentCaseLender.status == CaseLenderStateEnum.Withdrawn)
    ) {
      return true;
    } else {
      return false;
    }
  }

  calculatemonetaryLAFee() {
    if (
      this.currentCaseLender.lenderArrangementFeePercent != null &&
      this.currentCaseLender.lenderArrangementFeePercent > 0 &&
      this.currentCaseLender.totalNetLoan != null &&
      this.currentCaseLender.totalNetLoan > 0
    ) {
      this.currentCaseLender.lenderArrangementFee =
        Math.round(this.currentCaseLender.totalNetLoan * this.currentCaseLender.lenderArrangementFeePercent * 100) /
        100;
    } else {
      this.currentCaseLender.lenderArrangementFee = 0;
    }
  }

  calculatemonetaryLAPercent() {
    if (
      this.currentCaseLender.lenderArrangementFee != null &&
      this.currentCaseLender.lenderArrangementFee > 0 &&
      this.currentCaseLender.totalNetLoan != null &&
      this.currentCaseLender.totalNetLoan > 0
    ) {
      this.currentCaseLender.lenderArrangementFeePercent =
        this.currentCaseLender.lenderArrangementFee / this.currentCaseLender.totalNetLoan;

      this.currentCaseLender.lenderArrangementFeePercent = parseFloat(
        this.currentCaseLender.lenderArrangementFeePercent.toFixed(4),
      );
    } else {
      this.currentCaseLender.lenderArrangementFeePercent = 0;
    }
  }

  getMortgageInterestTypeText(e: InterestRateTypeEnum) {
    switch (e) {
      case InterestRateTypeEnum.Fixed:
        return "Fixed";
      case InterestRateTypeEnum.Variable:
        return "Variable";
      default:
        break;
    }
  }

  getRepaymentTypeText(e: LoanRepaymentTypeEnum) {
    switch (e) {
      case LoanRepaymentTypeEnum.InterestOnly:
        return "Interest only";
      case LoanRepaymentTypeEnum.Repayment:
        return "Capital & Interest";
      default:
        break;
    }
  }

  addClass(star: number, id: string) {
    this.feedBackService.addClass(star, id);
  }

  removeClass(star: number, id: string, rating) {
    this.feedBackService.removeClass(star, id, rating);
  }

  isFeedBackFormDisabled() {
    return this.feedBackService.isFeedBackFormDisabled(this.isLender, this.feedBackDTO);
  }

  updateRating(star, rating) {
    this.feedBackDTO = this.feedBackService.updateRating(star, rating, this.feedBackDTO);
  }

  submitFeedBack() {
    if (this.isLender) {
      this.feedBackDTO.organisationId = this.currentDeal.brokerOrganisationId;
      this.feedBackDTO.brokerUserId = this.currentDeal.brokerUserId;
      this.feedBackDTO.organisation = null;
      this.feedBackDTO.brokerUser = null;
      this.feedBackDTO.reviewerUserId = 0;
      this.feedBackDTO.reviewerUser = null;
    } else {
      this.feedBackDTO.lenderId = this.currentCaseLender.lenderId;
      this.feedBackDTO.lender = null;
      this.feedBackDTO.reviewerUserId = 0;
      this.feedBackDTO.reviewerUser = null;
    }

    this.feedBackClient.addFeedBack(this.currentCaseLender.id, true, this.feedBackDTO).then((response) => {
      if (this.isLender) {
        this.$auth.clearSelectedNavMenuAndFilterStorageData();
        this.$location.path("/userdashboard");
      } else {
        this.$location.path(`/${this.prevPath}/${this.currentDeal.id}`);
      }
    });
  }

  showBrokerFeedBack() {
    this.feedBackDTO.isBrokerFeedback = true;
    this.showBrokerFeedBackModal = true;
  }

  onClickDeleteMessageButton(message: DealLenderMessage) {
    this.showdeleteChatMessageModal = true;
    this.messageContent = "Are you sure you want to delete a selected message?";
    this.selectedDealLenderMessageDto = message;
    this.showConfirmDeleteButton = true;
  }

  deleteChatMessage() {
    this.dataLoading = true;
    this.dealLenderMessageClient
      .markAsDeleted(this.selectedDealLenderMessageDto.id)
      .then((response) => {
        this.currentCaseLender.dealLenderMessage = this.currentCaseLender.dealLenderMessage.filter(
          (x) => x.id != this.selectedDealLenderMessageDto.id,
        );
      })
      .catch((error) => {
        this.messageContent = "Sorry, something went wrong while deleting message. Please try again.";
      })
      .finally(() => {
        this.showdeleteChatMessageModal = false;
        delete this.selectedDealLenderMessageDto;
        this.showConfirmDeleteButton = false;
        this.dataLoading = false;
      });
  }

  getSenderMessageRole() {
    if (this.isLender) {
      return MessageRoleEnum.Lender;
    } else if (this.isBroker) {
      return MessageRoleEnum.Broker;
    } else if (this.isAdmin) {
      return MessageRoleEnum.Admin;
    } else if (this.isClient) {
      return MessageRoleEnum.Client;
    }
  }

  isCurrentUserAllowedToSendChat() {
    if (this.currentUser && this.currentDeal && (this.toggleFeedbackSection || this.showFeedbackSectionLender)) {
      return this.sharedHeadsOfTermsService.isCurrentUserAllowedToSendChat(
        this.isBroker,
        this.currentDeal.status,
        this.currentDeal.isReferredToConnect,
        this.currentUser.isConnectUser,
      );
    }
    return false;
  }
}
